import { useRef, useState } from 'react'

import { getAIBillingBalance } from '../../../../api'
import {
  getIsGretaAIChatBalanceExhausted,
  getIsGretaAIChatPackageLocked,
} from '../../GretaAIChat.utils'

export function useGretaAIChatBalance() {
  const [isLimitReached, setIsLimitReached] = useState(false)
  const isLimitReachedRef = useRef(isLimitReached)

  const [isLocked, setIsLocked] = useState(false)
  const isLockedRef = useRef(isLocked)

  // Requests can resolve out of order — only the latest one may update state.
  const latestRequestIdRef = useRef(0)

  function setLimitReached(value) {
    isLimitReachedRef.current = value
    setIsLimitReached(value)
  }

  function setLocked(value) {
    isLockedRef.current = value
    setIsLocked(value)
  }

  async function checkBalance() {
    const requestId = ++latestRequestIdRef.current

    try {
      const response = await getAIBillingBalance()
      const isExhausted = getIsGretaAIChatBalanceExhausted(response)

      if (requestId !== latestRequestIdRef.current) {
        // A newer check may already have resolved and changed the known
        // state — a stale response must defer to it, not authorize on its own.
        return isLimitReachedRef.current
      }

      setLimitReached(isExhausted)
      setLocked(false)

      return isExhausted
    } catch (error) {
      if (requestId !== latestRequestIdRef.current) {
        return isLimitReachedRef.current
      }

      if (getIsGretaAIChatPackageLocked(error)) {
        setLimitReached(false)
        setLocked(true)

        return false
      }

      // A failed check must not block sending on its own — only a confirmed
      // exhausted balance does; keep whatever we last knew.
      return isLimitReachedRef.current
    }
  }

  return { checkBalance, isLimitReached, isLocked }
}
